// shared/pdf/documents/DayBookDocument.jsx
import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow } from '../components/PdfTable';
import { fmtINR, cap } from '../pdfUtils';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const COLS = [
  { label: 'Voucher No', flex: 1.2 },
  { label: 'Type',       flex: 0.9 },
  { label: 'Narration',  flex: 3 },
  { label: 'Dr (₹)',     flex: 1, align: 'right' },
  { label: 'Cr (₹)',     flex: 1, align: 'right' },
];

export default function DayBookDocument({ data, theme: themeKey, orientation, sections, filters }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Day Book" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && <PdfFilterLine filters={filters} theme={t} />}
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Total Receipts', value: fmtINR(data.summary?.totalReceipts), color: t.statusGreen },
              { label: 'Total Payments', value: fmtINR(data.summary?.totalPayments), color: t.statusRed },
              { label: 'Net',            value: fmtINR(data.summary?.net),           color: t.body    },
            ]} />
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {(data.rows || []).map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t}
              values={[row.voucherNo, cap(row.entryType), row.narration || '—', fmtINR(row.totalDr), fmtINR(row.totalCr)]}
            />
          ))}
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}


